import { personaType, stateType } from "../../state";
import { AreYouSurePopup } from "../Common/AreYourSurePopup";

export function DeletePopup({ state }: stateType) {
  function handleDelete() {
    let personas = state.saveState.personaPrediction.personas;
    let tmp: personaType[] = [];
    for (let i = 0; i < personas.length; i++) {
      if (i === state.saveState.personaPrediction.personaselected) {
        continue;
      }
      tmp.push(personas[i]);
    }
    state.saveState.personaPrediction.personaselected = Math.max(
      state.saveState.personaPrediction.personaselected - 1,
      0
    );
    state.saveState.personaPrediction.personas = tmp;
    state.setIsDeletePersonaOpen(false);
    state.setSaveState(state.saveState);
  }

  return (
    <AreYouSurePopup
      state={state}
      title="Delete Persona"
      message="Are you sure you want to delete this Persona?"
      handleContinue={handleDelete}
      handleCancel={() => state.setIsDeletePersonaOpen(false)}
      isOpenTF={state.isDeletPersonaOpen}
      continueLabel="Delete"
    ></AreYouSurePopup>
  );
}
